import {Module} from "../common/Module";
import {createPrivilegeIdentifier, isPrivileged, Privileges} from "../../config/Privileges";
import {ProjectAreaName, ProjectModule, ProjectStageIdPath, ProjectStagePhaseIdPath} from "./Project";
import {Nullable} from "../common/Nullable";
import {ProjectUserPrivileges} from "./ProjectUserPrivileges";
import {AuthenticatedUser} from "../users/AuthenticatedUser";


export interface IProjectAppendixModule extends Omit<Module, 'isPrivileged' > {
    isPrivileged: (
        projectPrivileges: Nullable< ProjectUserPrivileges >,
        stageIdPath: ProjectStageIdPath,
        authUser: Nullable< AuthenticatedUser >,
        privilege: string
    ) => boolean
}

export const ProjectAppendixModule: IProjectAppendixModule = {
    identifier: "project_appendix",
    isPrivileged: (
        projectPrivileges: Nullable< ProjectUserPrivileges >,
        stageIdPath: ProjectStageIdPath,
        authUser: Nullable< AuthenticatedUser >,
        privilege: string
    ) => {
        const privilegeId = createPrivilegeIdentifier(
            ProjectAreaName,
            ProjectAppendixModule.identifier,
            privilege
        )

        return ProjectModule.isPrivilegedStage(
            projectPrivileges,
            privilege,
            stageIdPath,
            authUser,
            privilegeId
        )
    }
}